import { EVENT_ENVIRONMENT } from './config';

export const KAFKA_TOPICS = {
    EXPERIENCE_NAVIGATION: `${ EVENT_ENVIRONMENT }-experience-navigation`
};

export const ASSUMPTION_TYPES = {
    'OPERATOR': 'operator',
    'PROXY': 'proxy',
    'DELEGATE': 'delegate'
};

export const ADMIN_SESSION_START_KEY = 'deck.adminSessionStart';